// add remove class on scroll header
function handleScroll() {
  const element = document.getElementById("stickyheader");
  const scrollPosition = window.scrollY;

  if (scrollPosition > 50) {
    element.classList.add("scroll-active");
  } else {
    element.classList.remove("scroll-active");
  }
}
window.addEventListener("scroll", handleScroll);

// add remove class on hover

const element = document.getElementById("stickyheader");

element.addEventListener("mouseover", () => {
  element.classList.add("scroll-hover");
});

element.addEventListener("mouseout", () => {
  element.classList.remove("scroll-hover");
});

// Mega dropdown on hover

// Get all elements whose ID starts with "Details-HeaderMenu-" and ends with a number
// const detailsElements = document.querySelectorAll(
//   '[id^="Details-HeaderMenu-"]'
// );

// // Add event listeners to each element
// detailsElements.forEach((element) => {
//   element.addEventListener("mouseover", () => {
//     element.setAttribute("open", "true");
//   });

//   element.addEventListener("mouseout", () => {
//     element.removeAttribute("open");
//   });
// });
